import Install from '@container/install/Install';
import Order from '@container/order/Order';
import Notice from '@container/notice/Notice';
import Doc from '@container/doc/Doc';
import BrandDoc from '@container/brandDoc/BrandDoc';

const isOrder = process.env.REACT_APP_MAIN_PATH === 'Order';
let routes = [
    {
        name: 'Main',
        path: '/',
        element: isOrder ? <Order /> : <Install />,
    },
    {
        name: 'Install',
        path: '/Install',
        element: <Install />,
    },
    {
        name: 'Order',
        path: '/Order',
        element: <Order />,
    },
    {
        name: 'open',
        path: '/open',
        element: <Install />,
    },
    {
        name: 'notice',
        path: '/notice',
        element: <Notice />,
    },
    {
        name: 'Doc',
        path: '/Doc',
        element: <Doc />,
    },
    {
        name: 'BrandDoc',
        path: '/BrandDoc',
        element: <BrandDoc />,
    },
    {
        name: 'Main',
        path: '*',
        element: isOrder ? <Order /> : <Install />,
    },
];

const pathnameList = window.location.pathname.split('/');

if (pathnameList[pathnameList.length - 1] === '') {
    pathnameList.pop();
}

if (pathnameList.length > 2) {
    pathnameList.pop();
    const baseName = pathnameList.join('/');

    routes = routes.map((route) => {
        if (route.path !== '*') {
            route.path = `/${baseName}${route.path}`;
        }

        return route;
    });
}

export default routes;
